import { OpeningHours } from '../types';

export const formatTime = (time: string): string => {
  const [hours, minutes] = time.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'pm' : 'am';
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${displayHour}${minutes === '00' ? '' : `:${minutes}`}${ampm}`;
};

export const formatOpeningHours = (openingHours: OpeningHours): Array<{ day: string; hours: string }> => {
  const days = [
    { key: 'monday', name: 'Monday' },
    { key: 'tuesday', name: 'Tuesday' },
    { key: 'wednesday', name: 'Wednesday' },
    { key: 'thursday', name: 'Thursday' },
    { key: 'friday', name: 'Friday' },
    { key: 'saturday', name: 'Saturday' },
    { key: 'sunday', name: 'Sunday' }
  ];

  return days.map(({ key, name }) => {
    const dayHours = openingHours[key as keyof OpeningHours];
    const hours = dayHours.closed 
      ? 'Closed' 
      : `${formatTime(dayHours.open)} - ${formatTime(dayHours.close)}`;
    
    return { day: name, hours };
  });
};


